
      window.addEventListener("vite:preloadError", (event) => {
        console.warn(
          "[vite:preloadError] Reloading the page to recover from chunk error...",
          event
        );
        window.location.reload();
      });
    